// 長視頻 豎版一大左右滑動循環
import VideoBox from 'component/VideoBoxVertical'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Wrapper } from './Styled'
import EffectStack from 'swiperEffects/cardStack'
import { memo, useCallback, useState } from 'react'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import { AreaBoxSwiperTemplateWrapper, MaskedBase64Background } from '../Styled'
import { useDuplicatedArray } from 'hooks/useDuplicatedArray'

interface Template10Props {
  videoData: any[]
}

function Template10({ videoData: videoDataProp }: Template10Props) {
  const videoData = useDuplicatedArray(videoDataProp, 5)

  const [currentSlide, setCurrentSlide] = useState(0)

  const currentItem: any = videoData[currentSlide]

  const currentImage = currentItem?.coverphoto_v

  const onSlideChange = useCallback((swiper: any) => {
    setCurrentSlide(swiper.realIndex)
  }, [])

  const { ref, visible } = useIntersectionObserver<HTMLDivElement>({
    /* Optional options */
    defaultVisible: false,
    threshold: 0,
    triggerOnce: false,
  })

  return (
    <AreaBoxSwiperTemplateWrapper>
      <Wrapper ref={ref}>
        <MaskedBase64Background className={'swiper-no-swiping'} src={currentImage} noLazy={visible} allowUnload />
        <Swiper
          effect="stack"
          onSlideChange={onSlideChange}
          modules={[EffectStack]}
          virtualTranslate={true}
          loop={true}
          nested={true}
        >
          {videoData?.map((item, i) => {
            return (
              <SwiperSlide key={item.id}>
                <VideoBox
                  overflow={true}
                  textAlign="center"
                  videoInfo={item}
                  width="auto"
                  noLazy={visible}
                  fontSize={'0.41rem'}
                  allowUnload
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </Wrapper>
    </AreaBoxSwiperTemplateWrapper>
  )
}

export default memo(Template10)
